import { Contract, PriceList, Stake, Token } from '@jdiyield/interfaces'
import BigNumber from 'bignumber.js'
import Web3 from 'web3'

import StakingRewards from '../abi/StakingRewards.json'
import { calculate } from '../calculate'
import getNodeUrl from '../rpcRandom'
import { findToken } from '../utils'

export const getQuickSwapFarm = async (
  walletAddress: string,
  ct: Contract,
  tokens: Token[],
  priceList: PriceList,
  web3Prop: Web3
): Promise<Stake[]> => {
  const { contractAddress, rewardAddress, routerAddress } = ct
  const web3 = web3Prop || new Web3(getNodeUrl(137))
  const contract = new web3.eth.Contract(StakingRewards as any, contractAddress)
  const balance = (await contract.methods.balanceOf(walletAddress).call()) as string
  if (balance === '0') return []
  const lpAddress = (await contract.methods.stakingToken().call()) as string
  const _pendingReward = (await contract.methods.earned(walletAddress).call()) as string
  // const lpcontract = new web3.eth.Contract(UniswapV2PairABI as any, lpAddress)
  // const availableBalanceOf = await lpcontract.methods.balanceOf(walletAddress).call()
  const _balanceLPPair = await calculate(
    web3,
    {
      //     pool: number
      // balance: string
      // lpAddress: string
      // availableBalanceOf: string
      lpAddress,
      pool: 0,
      balance,
      rewardAddress,
      availableBalanceOf: '0'
    },
    routerAddress,
    tokens,
    priceList
  )
  const rewardInfo = findToken(tokens, rewardAddress)
  const reward = new BigNumber(_pendingReward).dividedBy(`1e${rewardInfo?.decimals || 18}`).toNumber()

  const result = {
    ...ct,
    ..._balanceLPPair,
    availableBalanceOf: '0',
    reward,
    rewardSymbol: rewardInfo?.symbol || '???'
  } as Stake
  return [result]
}
